export { CreatePostPage } from "./ui/create-post-page"
